import React from 'react';
import semicircle from '../../assets/images/semicircle.png';
import css from './Semicircle.module.css';

const Semicircle = () => (
  <img alt="Semicircle" src={semicircle} className={css.semicircle} />
);

export default Semicircle;
